module.exports = __webpack_public_path__ + "img/fixed.64ca8f3e.png";